import React, { Fragment, useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Loader from '../component/common/loader';
import AuthImage from "../component/AuthImage/AuthImage";
import path from '../routes/path';
import siteConfig from '../config/site-config';
import './scss/AuthLayout.scss'
import { courseAction } from "../store/courseSlice";
import { useDispatch } from "react-redux";
import Header from "../component/Header/Header";
import { returnNumberByLang } from "../helper/CommonFunctions";
import { useTranslation } from 'react-i18next';
import Footer from '../component/Footer/Footer';

const AuthLayout = (props) => {
    const dispatch = useDispatch()
    const { t } = useTranslation();
    useEffect(() => {
        if (!window.location.href.toString().includes("/courses-list-new"))
            dispatch(courseAction.setSearchParam(""));
    }, [window.location.href]);
    return (
        <Fragment >
            <div className="auth-page-headernot-sticky">
                <Header />
            </div>
            <div className="lgon-register-page-wrapper">
                <div className="container">
                    {/*<div className="login-logo">*/}
                    {/*    <Link to={`${process.env.PUBLIC_URL}${path.home}`}>*/}
                    {/*        <img src={siteConfig.company_logo} alt={siteConfig.company_name} />*/}
                    {/*    </Link>*/}
                    {/*</div>*/}
                    <div className="auth-page">
                        <div className="row">
                            <div className="col-lg-5 p-0 align-self-center">
                                <AuthImage />
                            </div>
                            <div className="col-lg-7 p-0 align-self-center">
                                <Outlet />
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="auth-layout-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="footer-bottom">
                                <p>{t('footer.current_year', { count: returnNumberByLang(siteConfig.copyright_year) })} {t('footer.footer_copy_text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <Footer />
        </Fragment>
    );
}

export default AuthLayout;
